import React, { useState } from 'react';
import InputField from '../../components/InputField';
import Button from '../../components/Button';
import { supabase } from '../../lib/supabase';

function SignUpPage({ onNavigate }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setLoading(true);

    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: { emailRedirectTo: window.location.origin },
    });

    if (error) {
      setError(error.message);
    } else {
      setSuccess(true);
    }
    setLoading(false);
  }

  if (success) {
    return (
      <div className="min-h-screen bg-surface-page flex items-center justify-center px-6">
        <div className="w-full max-w-sm text-center">
          <h1 className="text-h2 text-neutral-900 mb-3">Check your email</h1>
          <p className="text-body text-neutral-500">
            We sent a confirmation link to <strong>{email}</strong>. Click it to activate your account.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-surface-page flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <h1 className="text-h2 text-neutral-900 mb-2">Create an account</h1>
        <p className="text-body text-neutral-500 mb-8">
          Already have an account?{' '}
          <button
            type="button"
            onClick={() => onNavigate('signin')}
            className="text-primary-500 font-semibold hover:text-primary-400 transition-colors duration-fast focus:outline-none underline"
          >
            Sign in
          </button>
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-5">
          <InputField
            id="email"
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
          />
          <InputField
            id="password"
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Min. 6 characters"
            required
          />

          {error && (
            <p className="text-caption text-error">{error}</p>
          )}

          <Button type="submit" variant="primary" size="md" loading={loading} className="w-full">
            Create account
          </Button>
        </form>
      </div>
    </div>
  );
}

export default SignUpPage;
